import { render, staticRenderFns } from "./m-text-validate-field.vue?vue&type=template&id=453b8054&scoped=true&"
import script from "./m-text-validate-field.vue?vue&type=script&lang=js&"
export * from "./m-text-validate-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453b8054",
  null
  
)

export default component.exports